<ng-template #ApproveDialogTemplate>
  <tur-generic-modal-content
    [acceptanceAllowed]="true"
    (confirm)="onAcceptApproveDialog()"
    (cancel)="onCloseApproveDialog()"
    id="ApproveDialog"
    modalTitle="{{ 'APPROVE_DIALOG_TITLE' | translate }}"
    acceptButtonLbl="{{ 'OK' | translate }}"
    cancelButtonLbl="{{ 'CANCEL' | translate }}"
    confirmationMessage="{{ 'APPROVE_DIALOG_MESSAGE' | translate }}">
    <div class="d-flex justify-content-center">
      @if (spinnerActive) {
        <pas-spinner [size]="'small'"></pas-spinner>
      }
    </div>
  </tur-generic-modal-content>
</ng-template>

<ng-template #RejectApprovalDialogTemplate>
  <tur-generic-modal-content
    [acceptanceAllowed]="rejectComment && rejectComment !== ''"
    (confirm)="onAcceptRejectApprovalDialog()"
    (cancel)="onCloseRejectApprovalDialog()"
    modalTitle="{{ 'REJECT' | translate }}"
    acceptButtonLbl="{{ 'OK' | translate }}"
    cancelButtonLbl="{{ 'CANCEL' | translate }}"
    confirmationMessage="{{ 'REJECT_APPROVAL_DIALOG_REJECT_COMMENT' | translate }}">
    <pas-input [(ngModel)]="rejectComment" [maxLength]="250" id="rejectComment"></pas-input>
    <div class="d-flex justify-content-center">
      @if (spinnerActive) {
        <pas-spinner [size]="'small'"></pas-spinner>
      }
    </div>
  </tur-generic-modal-content>
</ng-template>

<ng-template #ReprocessDialogTemplate>
  <tur-generic-modal-content
    [acceptanceAllowed]="true"
    (confirm)="onAcceptReprocessDialog()"
    (cancel)="onCloseReprocessDialog()"
    id="ReprocessDialog"
    modalTitle="{{ 'REPROCESS_DIALOG_TITLE' | translate }}"
    acceptButtonLbl="{{ 'OK' | translate }}"
    cancelButtonLbl="{{ 'CANCEL' | translate }}"
    confirmationMessage="{{ 'REPROCESS_DIALOG_MESSAGE' | translate }}">
    <div class="d-flex justify-content-center">
      @if (spinnerActive) {
        <pas-spinner [size]="'small'"></pas-spinner>
      }
    </div>
  </tur-generic-modal-content>
</ng-template>
